import React, { useState } from 'react';
import { Box, Typography, Button, Alert, Snackbar } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { format } from 'date-fns';
import TransactionShortTable from './TransactionShortTable';
import TransactionWorkTable from './TransactionWorkTable';

const initialWorkRows = [
  { name: '' },
  { name: '' },
  { name: '' },
  { name: '' },
  { name: '' },
  { name: 'Setting' },
  { name: 'Polish' },
  { name: 'Cutting' },
  { name: 'Galai' },
  { name: '' },
];

const TransactionOther2 = () => {
  const [workRows, setWorkRows] = useState(initialWorkRows);
  const [shortTableValues, setShortTableValues] = useState(Array(7).fill(''));
  const [saveSuccess, setSaveSuccess] = useState(false);
  const currentDate = new Date();

  const handleWorkTableChange = (rowIdx, field, value) => {
    setWorkRows(rows => rows.map((row, idx) => idx === rowIdx ? { ...row, [field]: value } : row));
  };

  const handleShortTableChange = (idx, value) => {
    setShortTableValues(values => values.map((v, i) => i === idx ? value : v));
  };

  const handleSave = () => {
    setSaveSuccess(true);
  };

  return (
    <Box sx={{ mt: 8, px: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => window.history.back()} variant="outlined" color="primary" sx={{ mr: 2 }}>
          Back
        </Button>
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ textAlign: 'right' }}>
            Date: {format(currentDate, 'dd/MM/yyyy')}
          </Typography>
        </Box>
      </Box>
      <TransactionShortTable shortRows={[ '24K GOLD', '24K GOLD', 'Jink', 'Chain', 'Ball', 'Work', 'Reject' ]} rightCells={shortTableValues} onChange={handleShortTableChange} />
      <TransactionWorkTable rows={workRows} onChange={handleWorkTableChange} />
      <Box sx={{ mt: 2, textAlign: 'right' }}>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Save Transaction
        </Button>
      </Box>
      <Snackbar open={saveSuccess} autoHideDuration={3000} onClose={() => setSaveSuccess(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={() => setSaveSuccess(false)} severity="success" sx={{ width: '100%' }}>
          Transaction saved successfully!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TransactionOther2; 